import ParamExplorationCol from '@/views/parametres/configs/param-sagefemme/param-exploration-col'
import ParamEtatSeins from '@/views/parametres/configs/param-sagefemme/param-etat-seins'

import store_config from '@/store/mods/parametres/config'

export default {
    name: 'param-sagefemme',
    components: {
        ParamExplorationCol, ParamEtatSeins
    },
    props: [],
    data() {
        return {
            config_to_show: '1',
            params_cpn: {},
            is_loading: true,
            is_empty: false
        }
    },

    computed: {

    },

    mounted() {
        this.getListeParamCPN()
    },

    methods: {
        changeTab(tabindex) {
            this.config_to_show = tabindex
        },

        getListeParamCPN() {
            this.is_loading = true
            store_config.getAllParamCpn().then((response) => {
                this.params_cpn = response
                this.is_empty = Object.keys(response).length === 0

                this.is_loading = false
            })
        }
    }
}